module.exports = __webpack_public_path__ + "img/FE_A2_back_en.7fa679fc.png";